import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import dayjs from "dayjs";

export const generatePDF = (formData, sectionName) => {
  const doc = new jsPDF();

  // Definir variables antes de img.onload
  const tableRows = [];
  const fieldNames = {
    infracciones: "Datos de infracciones penales/administrativas",
    salud: "Datos de salud, accidentes, lesiones",
    sistemaTratamiento: "Sistema de Tratamiento",
    criterioArchivo: "Criterio de Archivo",
    lugarAlmacenamiento: "Lugar de Almacenamiento",
    fechaAlta: "Fecha de Alta",
    mecanismoCifrado: "Mecanismo de Cifrado",
    nombreSede: "Nombre de la Sede",
    accesos: "Accesos",
    equiposAdicionales: "Equipos Adicionales",
    sai: "Sistema de Alimentación Ininterrumpida (SAI)",
    domicilioSede: "Domicilio de la Sede",
    codigoPostalSede: "Código Postal (C.P.)",
    poblacionSede: "Población",
    provinciaSede: "Provincia",
    fechaAntiguedadSede: "Fecha de Antigüedad de la Sede",
    nombrePersonal: "Nombre y Apellidos",
    dni: "D.N.I.",
    domicilioPersonal: "Domicilio",
    codigoPostalPersonal: "Código Postal",
    poblacionPersonal: "Población",
    provinciaPersonal: "Provincia",
    telefono: "Teléfono",
    email: "Email",
    fechaAntiguedadPersonal: "Fecha de Antigüedad",
    funcion: "Función",
    nombreEncargado: "Nombre de la Empresa",
    nif: "N.I.F.",
    domicilioEncargado: "Domicilio",
    codigoPostalEncargado: "Código Postal",
    poblacionEncargado: "Población",
    provinciaEncargado: "Provincia",
    tipoServicio: "Tipo de Servicio",
    fechaAntiguedadEncargado: "Fecha de Antigüedad",
    nombreUsuario: "Nombre de Usuario del Equipo",
    tipo: "Tipo de Equipo",
    impresora: "Impresora",
    sistemaOperativo: "Sistema Operativo",
    funcionEquipo: "Función",
    operadores: "Operadores",
    fechaAdquisicion: "Fecha de Adquisición",
    numPantallas: "Numero pantallas",
    fechaBaja: "Fecha de baja",
    apellidos: "Apellidos",
    nombre: "Nombre",
    departamento: "Departamento",
    ordenador:"Ordenador",
    pantallas:"Pantallas",
    movil:"Movil",
    otroHardware:"Otro Hardware",
    accesoServidor:"Acceso al servidor",
    office:"Office",
    abbantia:"Abbantia",
    accesoRemoto:"Acceso Remoto",
    appInterna:"App Interna",
    observaciones:"Observaciones",
    usuarioAbbantia:"Usuario Abbantia",
    pinPortero:"Pin Portero",
    firmadoPor:"Firmado por",
    fechaFirma:"Fecha Firma",
    tieneFechaBaja:"Tiene Fecha de Baja",
    nombreEmpleado:"Nombre empleado",
  };

  // Cargar imagen del logo en PNG
  const img = new Image();
  img.src = "/life-pro-nutrition-logo.png";

  img.onload = () => {
    // Obtener el nombre del empleado
    const userName = formData.nombreEmpleado ? formData.nombreEmpleado.toUpperCase() : "SIN NOMBRE";

    // Agregar Logo
    doc.addImage(img, "PNG", 14, 10, 50, 15);

    // Definir espacio extra después del logo
    const yLogoBottom = 10 + 15; // 10 (posición inicial) + 15 (altura del logo)
    const lineHeight = 7; // Altura aproximada de una línea
    const extraSpacing = lineHeight * 2; // Espacio equivalente a 5 líneas

    // Agregar título de la sección
    const ySectionTitle = yLogoBottom + extraSpacing; // Espaciado correcto
    doc.setFontSize(18);
    doc.text(sectionName, 14, ySectionTitle);

    // Definir posición para "Datos ingresados:"
    const yDatosIngresados = ySectionTitle + lineHeight; // Espacio extra
    doc.setFontSize(12);
    doc.text("Datos ingresados:", 14, yDatosIngresados);

    // Ajustar tabla para que no se solape con "Datos ingresados:"
    const yTableStart = yDatosIngresados + lineHeight; // Espacio suficiente

    // Construir filas de la tabla
    Object.entries(formData).forEach(([key, value]) => {
      let formattedValue = value;

      if (key === "fechaBaja" && (!value || value === "null" || value === "")) {
        formattedValue = "No especificada"; // Si no hay fecha, asignamos un valor predeterminado
      } else if (key.includes("fecha") && value) {
        formattedValue = dayjs(value).format("MM/YYYY"); // Formatear fecha correctamente
      }

      const booleanValue = formattedValue === true ? "Sí" : formattedValue === false ? "No" : formattedValue || "-";
      
      tableRows.push([fieldNames[key] || key, booleanValue]); // Cambia "N/A" por "-"
    });

    autoTable(doc, {
      startY: yTableStart,
      head: [[userName, ""]],
      body: tableRows,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [0, 102, 204] },
      alternateRowStyles: { fillColor: [240, 240, 240] },
    });

    // Ajustar la posición del footer para subirlo un 5%
    const pageHeight = doc.internal.pageSize.height;
    const footerPosition = pageHeight - 24; // Se sube el footer 14 puntos (5% de la altura de una hoja A4)

    // Agregar el nombre del usuario en el footer
    doc.setFontSize(10);
    doc.text(`Empleado: ${userName}`, 14, footerPosition - 5);

    // Agregar texto legal en el footer
    const legalText = 
      "Este documento contiene información de carácter confidencial y está destinado exclusivamente a su uso en el marco del cumplimiento de la normativa de protección de datos. " +
      "De acuerdo con el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), los datos aquí reflejados han sido recopilados con la única finalidad de cumplir con las obligaciones legales en materia de seguridad y tratamiento de datos. " +
      "Está prohibida su reproducción, distribución o divulgación sin la autorización expresa de la empresa responsable del tratamiento. En caso de recepción indebida, por favor notifíquelo y proceda a su eliminación inmediata. " +
      "Para más información sobre el tratamiento de estos datos, consulte nuestra política de privacidad.";

    doc.setFontSize(8);
    const splitLegalText = doc.splitTextToSize(legalText, 180); // Ajusta el ancho del texto
    doc.setTextColor(100); // Cambia el color a un gris medio

    doc.text(splitLegalText, 14, footerPosition);

    // Generar nombre del archivo con el nombre del empleado
    const fileName = `${sectionName.replace(/\s+/g, "_")}_${userName.replace(/\s+/g, "_")}.pdf`;

    doc.save(fileName);
  };
};
